"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _tracking = require("settings-ui-app/utils/tracking");

var _MovingPageHOC = _interopRequireDefault(require("settings-ui-lib/components/hoc/MovingPageHOC"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var route = 'email-temp';
var URL = "/content/" + _hubspot.default.get() + "/settings/email";
var _default = {
  reducer: function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return state;
  },
  routes: _react.default.createElement(_reactRouter.Route, {
    path: route,
    component: (0, _MovingPageHOC.default)({
      heading: _react.default.createElement(_FormattedMessage.default, {
        message: "marketing.movingPages.email.heading"
      }),
      subText: _react.default.createElement(_UILink.default, {
        href: URL
      }, _react.default.createElement(_FormattedMessage.default, {
        message: "marketing.movingPages.email.subText"
      }))
    }),
    onEnter: (0, _tracking.trackScreenUsingSideNav)()
  }),
  route: route
};
exports.default = _default;
module.exports = exports.default;